import { render, staticRenderFns } from "./imageTypeList.vue?vue&type=template&id=228a999e&scoped=true&"
import script from "./imageTypeList.vue?vue&type=script&lang=js&"
export * from "./imageTypeList.vue?vue&type=script&lang=js&"
import style0 from "./imageTypeList.vue?vue&type=style&index=0&id=228a999e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a999e",
  null
  
)

export default component.exports